import React from "react";
import img from "../../Assets/is.png";
import { useSelector } from "react-redux";
const Refundable = () => {
  const clientConfig = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0]
  );
  return (
    <>
      {clientConfig?.cartInfo && (
        <div class="d-flex justify-content-start p-4  pt-2 pb-2 mt-3 voucher-bg bor hai refundalbeCard">
          <div class="lsss mr-2 d-flex align-item-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="42"
              height="42"
              viewBox="10 0 50 54"
              role="img"
              aria-label="information icon"
            >
              {" "}
              <circle
                cx="32.5"
                cy="27"
                r="16.5"
                fill="none"
                stroke="var(--egiftcard-icon-color)"
                stroke-width="3"
              />{" "}
              <rect
                x="31"
                y="25"
                width="3"
                height="10"
                rx="2.5"
                ry="2.5"
                fill="var(--egiftcard-icon-color)"
              />{" "}
              <circle
                cx="32.5"
                cy="20"
                r="1.5"
                fill="var(--egiftcard-icon-color)"
              />{" "}
            </svg>
          </div>
          <div class="earncheckitem">
            {clientConfig?.cartInfo === true ? (
              clientConfig?.cartInfoMessage
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Refundable;
